import { useSitePreviews } from "../useSitePreviews/useSitePreviews"

interface UseEntitiesValue {
  entitiesHasData: boolean
  entitiesIsFetched: boolean
}

/**
 * Determines if the active organization has entities
 *
 * @returns The entities status
 */
export const useEntities = (): UseEntitiesValue => {
  const { sitePreviewsData, sitePreviewsIsFetched } = useSitePreviews()

  return {
    entitiesIsFetched: sitePreviewsIsFetched,
    entitiesHasData: (sitePreviewsData?.length ?? 0) > 0,
  }
}
